<template>
    <div style="width: 100%; height: 100%">
        <el-container>
            <el-main>
                <router-view />
            </el-main>
        </el-container>

    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        },
    };
</script>

<style lang='less' scoped>
    .el-container {
        width: 100%;
        height: 100%;
    }

    .el-header {
        
        color: #fff;
    }
    .el-menu {
        height: 100%;
        padding: 0px;
    }
    .el-main {
        width: 100%;
        height: 100%;
        padding: 0px;
    }
</style>